import { environment } from '@/environments/environment'
import './app-version.scss'

export function AppVersion() {
  if (!environment.appVersion) {
    return null
  }

  return (
    <span className="app-version" data-testid="app-version">
      {environment.appVersion}
    </span>
  )
}
